<template>
  <div class="invoice">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>参展</BreadcrumbItem>
          <BreadcrumbItem>CMEF展讯通</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">CMEF展讯通</div>
      </div>
    </div>
    <div class="invoice-content" v-if="type == 1" style="padding: 30px 30px">
      <!-- <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="20"
        @submit.native.prevent
      >
        <FormItem prop="email">
          <Input
            style="width:400px;"
            type="email"
            placeholder="请输入你的邮箱完成登录验证"
            v-model="formInline.email"
          />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            style="width: 154px;height:36px;"
            :loading="loading"
          >去开通/修改信息</Button>
        </FormItem>
      </Form> -->
      <Button
        type="primary"
        @click="handleSubmit('formInline')"
        style="width: 154px; height: 36px"
        :loading="loading"
        >去开通/修改信息</Button
      >
      <!-- <div class="hint">
            <div>温馨提示:</div>
            <div>1.CMEF展讯通是专门供CMEF的展商收集展会观众数据，帮助企业进行展后分析的工具。</div>
            <div>2.以下信息填写请确保使用者是经企业确认的人员，且信息真实、有效。不得出售、转让使用权，如有不妥主办有权不提供展后数据。</div>
            <div>3.主开通人的申请需要上传加盖公司公章的说明，请提前准备好再进行申请。</div>
          </div> -->
    </div>
    <div v-if="type == 3" class="illustrate">
      <div>
        注意:请确定后填写，主开通人邮箱将作为企业数据接收邮箱，请确保为企业在职人员，邮箱一旦确定如需修改需要上传盖章证明。
      </div>
      <div>
        免责声明:如因企业自身问题，开通人的邮箱输入错误、转让收集邮箱、收集人不是企业在职人员等因素导致的数据泄露，主办方不承担任何责任。
      </div>
    </div>
    <div class="invoice-content" v-if="type == 2">
      <scan-creat></scan-creat>
    </div>
    <div class="invoice-content" v-if="type == 3">
      <!-- <scan-revise :infoList="datas"></scan-revise> -->
      <scan-revise :infoList="datas"></scan-revise>
    </div>
    <div class="invoice-content" v-if="type == 4">
      <scan-success></scan-success>
    </div>

    <iModal
      title="温馨提示"
      v-model="hihtModel"
      class-name="vertical-center-modal"
      width="1000px"
      :mask-closable="false"
    >
      <div class="hint">
        <div>
          1.CMEF展讯通是专门供CMEF的展商收集展会观众数据，帮助企业进行展后分析的工具。
        </div>
        <div>
          2.以下信息填写请确保使用者是经企业确认的人员，且信息真实、有效。不得出售、转让使用权，如有不妥主办有权不提供展后数据。
        </div>
        <div>
          3.主开通人的申请需要上传加盖公司公章的说明，请提前准备好再进行申请。
        </div>
      </div>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitReject()">确定</Button>
        <Button @click="hihtModel = false">取消</Button>
      </div>
    </iModal>
  </div>
</template>
  
  <script>
import { mapGetters, mapActions } from "vuex";
import scanCreat from "./components/exhibition-scan-creat.vue";
import scanRevise from "./components/exhibition-scan-revise.vue";
import scanSuccess from "./components/exhibition-scan-photo.vue";
import { validator } from "@/other/validator";
export default {
  name: "exhibition-scan",
  components: {
    scanCreat,
    scanRevise,
    scanSuccess,
  },
  data() {
    return {
      formInline: {
        email: "",
      },
      type: 1,
      loading: false,
      hihtModel: false,
      ruleInline: {
        email: validator.email,
      },
      startTime: "",
      endTime: "",
      datas: {},
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      joinInfo: "loginModule/getJoinInfo",
      exhibition: "loginModule/getExhibition",
    }),

    header() {
      return this.$store.state.header;
    },
  },
  created() {
    // this.type = 3
    this.timeNow();
  },
  methods: {
    ...mapActions({
      isEmailExist: "exhibitionScan/isEmailExist",
      GetAllContactPerson: "exhibitionScan/GetAllContactPerson",
      getcontacttime: "hostSetModule/getcontacttime",
    }),
    async timeNow() {
      let timer = await this.getcontacttime(this.exhibition.id);
      if (timer.time) {
        this.startTime = timer.time.startTime;
        this.endTime = timer.time.endTime;
      }
    },
    timerShow() {
      let startTime = new Date(this.startTime);
      let endTime = new Date(this.endTime);
      let currentTime = new Date();
      if (
        this.startTime &&
        this.endTime &&
        currentTime >= startTime &&
        currentTime <= endTime
      ) {
        return true;
      } else {
        this.$Message.warning("展讯通申请暂未开启，请耐心等待~");
        return false;
      }
    },
    async handleSubmit(name) {
      let timer = this.timerShow();
      if (!timer) {
        return;
      }
      this.hihtModel = true;
      // this.type = 3
      return;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;

      let req = {
        id: this.company.id,
        email: this.formInline.email,
      };
      let res = await this.isEmailExist(req);
      if (res.item1 == "empty") {
        let req1 = {
          id: this.company.id,
          email: this.formInline.email,
        };
        this.datas = req1;
        this.loading = false;
        this.type = 3;
      } else if (res.item1 == "error") {
        this.$Message.warning(res.item2);
        this.loading = false;
      } else if (res.item1 == "exist") {
        let req1 = {
          id: this.company.id,
          email: this.formInline.email,
        };
        this.datas = req1;
        this.loading = false;
        this.type = 3;
      }
    },
    handleSubmitReject() {
      this.type = 3;
      this.hihtModel = false;
    },
    validForm(name) {
      console.log(name);
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          console.log(valid);
          resolve(valid);
        });
      });
    },
  },
};
</script> 
  <style lang="scss" scoped>
.invoice {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 15px;
    padding: 0;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
  .invoice-tip {
    line-height: 34px;
    padding-left: 150px;
    color: #ff0000;
    span {
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.illustrate {
  margin: 10px 15px 0;
  color: #ff0000;
}
.hint {
  // color: #ff0000;
  margin: 30px 0;
  div {
    margin-top: 10px;
    font-size: 18px;
    // text-indent: 2em;
  }
  div:nth-child(1) {
    text-indent: 0em;
    // margin-top: 40px;
  }
}
</style>